import { DevicePoolTypes } from "./pools.config";

export function getOrgDeviceCount(pools: DevicePoolTypes[], orgID: string): number {
  return pools.reduce((sum, pool) => (pool.orgID === orgID ? sum + (pool.deviceCount ?? 0) : sum), 0);
}

export function findPoolByName(pools: DevicePoolTypes[], devicePool: string): DevicePoolTypes | undefined {
  return pools.find((pool) => pool.devicePool === devicePool);
}
